import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Box, Button } from '@mui/material';
import { SettingsAPI } from '../apis';
import { ConfigContext, ConfirmationDialog } from '../components';
import { constants } from '../constants';
import { removeCacheKeys } from '../utils/indexedDBCache';
export function SubmitSettings({ settings, selectedTab }) {
    const [isSubmitDialogOpen, setIsSubmitDialogOpen] = useState(false);
    const [isCancelDialogOpen, setIsCancelDialogOpen] = useState(false);
    const { configState, setConfigState } = React.useContext(ConfigContext);
    const saveSetting = async () => {
        try {
            if (settings) {
                // Invalidate settings cache before updating
                await removeCacheKeys([
                    'settings_data',
                    'page_image_data',
                    'header_image_data'
                ]);
                await SettingsAPI.putSettings({
                    background_color: settings.background_color,
                    button_color: settings.button_color,
                    header_background_color: settings.header_background_color,
                    workspace_name: settings.workspace_name,
                    workspace_name_color: settings.workspace_name_color,
                    button_text_color: settings.button_text_color,
                    welcome_message_color: settings.welcome_message_color,
                    industry_name: settings?.industry_name,
                    include_badge: settings?.include_badge,
                    show_logo: settings.show_logo,
                    show_workspace_name: settings.show_workspace_name,
                    show_deloitte_logo: settings.show_deloitte_logo
                }, configState?.settings?.id).then((response) => {
                    setConfigState((prevState) => ({
                        ...prevState,
                        settings: {
                            ...prevState.settings,
                            ...response
                        }
                    }));
                });
                if (settings.page_image_file) {
                    const fileFormData = new FormData();
                    fileFormData.append('image', settings.page_image_file);
                    const pageImgResponse = await SettingsAPI.patchSettingsImage(fileFormData, configState?.settings?.id);
                    if (pageImgResponse) {
                        await SettingsAPI.getSettingsImage('theme', 'image').then((response) => {
                            setConfigState((prevState) => ({
                                ...prevState,
                                settings: {
                                    ...prevState.settings,
                                    page_image: response
                                }
                            }));
                        });
                    }
                }
                if (settings.header_logo_image_file && settings.show_logo) {
                    const logoFormData = new FormData();
                    logoFormData.append('logo', settings.header_logo_image_file);
                    const logoImgResponse = await SettingsAPI.patchSettingsImage(logoFormData, configState?.settings?.id);
                    if (logoImgResponse) {
                        await SettingsAPI.getSettingsImage('theme', 'logo').then((response) => {
                            setConfigState((prevState) => ({
                                ...prevState,
                                settings: {
                                    ...prevState.settings,
                                    header_logo_image: response
                                }
                            }));
                        });
                    }
                }
                globalThis.window.history.back();
            }
        }
        catch (error) {
            console.error('Failed to save settings:', error);
        }
    };
    return (_jsx(Box, { sx: {
            display: 'flex',
            gap: '12px',
            width: '100%',
            justifyContent: 'end'
        }, children: selectedTab === 'Theme' && (_jsxs(_Fragment, { children: [_jsx(Button, { variant: "text", onClick: () => setIsCancelDialogOpen(true), style: { cursor: 'pointer' }, children: constants.submit_settings_discard_changes }), _jsx(ConfirmationDialog, { bodyText: constants.submit_settings_discard_body, isOpen: isCancelDialogOpen, setIsOpen: setIsCancelDialogOpen, submitButtonText: constants.confirm, submitFunction: () => {
                        globalThis.window.history.back();
                    }, actionType: "discard" }), _jsx(Button, { variant: "contained", onClick: () => setIsSubmitDialogOpen(true), style: { cursor: 'pointer' }, children: constants.submit_settings_save_changes }), _jsx(ConfirmationDialog, { bodyText: constants.submit_settings_save_body, isOpen: isSubmitDialogOpen, setIsOpen: setIsSubmitDialogOpen, submitButtonText: constants.confirm, submitFunction: saveSetting, actionType: "save" })] })) }));
}
